module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBd.ttf?v=158065c83c89a3d033e8036fa9115788";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBd.ttf
// module id = 682
// module chunks = 0